import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { PartnersMarquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Guide } from "@/components/Guide";
import { Checklist } from "@/components/Checklist";
import { Faq } from "@/components/Faq";
import { Services } from "@/components/Services";
import { Booking } from "@/components/Booking";
import { ChatWidget } from "@/components/ChatWidget";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      const t = setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 900);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <main className="bg-ink min-h-screen" data-testid="home-page">
      <Seo title="Haven & Hill Properties — Dubai Real Estate Advisory & Buyer's Guide"
           description="Boutique Dubai real-estate advisory with 20 years of leadership. Buyer's guide, curated listings, RERA-verified process support and free Zoom consultations."
           path="/" />
      <Navbar />
      <Hero />
      <PartnersMarquee />
      <About />
      <Guide />
      <Checklist />
      <Faq />
      <Services />
      <Booking />
      <Footer />
      <ChatWidget />
    </main>
  );
}
